// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Ewhw","rightAdornment":"Header_rightAdornment__3Eg_E"};